import { render, staticRenderFns } from "./prevent.vue?vue&type=template&id=abf28948&"
import script from "./prevent.vue?vue&type=script&lang=js&"
export * from "./prevent.vue?vue&type=script&lang=js&"
import style0 from "./prevent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports